import React from 'react';
import './Header.css';

const Header = () => {
  const currentDate = new Date().toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <header className="header">
      <div className="title-section">
        <h1>福州市烟草系统绩效对标数据大屏</h1>
      </div>
      <div className="date-section">
        <span>{currentDate}</span>
        <div className="update-status">
          <span className="status-indicator updating"></span>
          <span>数据更新中...</span>
        </div>
      </div>
      <div className="user-section">
        <span>管理员</span>
      </div>
    </header>
  );
};

export default Header;